export default __webpack_public_path__ + "static/media/Chat-Numbers-System-07.c7bf3e06.svg";